<template lang="html">
  <div class="row m-auto">
    <div class="col-12 mx-auto my-4 mb-0 py-3">
      <h3 v-if="isHightlighted" class="text-primary text-center">
        ¡Tu publicación destacada está online!
      </h3>
      <h3 v-else class="text-primary text-center">
        Tu publicación está online.
      </h3>
    </div>
    <div class="sell-online-body col-12 mx-0">
      <div class="row mx-auto my-4">
        <h5 v-if="!isHightlighted" class="col-12 text-center px-4">
          Pontenciá tus ventas <br><strong>destacando tu publicación</strong>
        </h5>
        <div
          :class="`${isHightlighted ? 'hl' : 'not-hl'} sell-online-image col-12 col-sm-5 pt-4 m-auto`">
        </div>
        <div class="col-12 text-center">
          <h3 v-if="isHightlighted" class="text-center">
            ¡Preparate para recibir consultas!
          </h3>
          <SquaredButton
            @click="goToHighlights"
            v-if="!isHightlighted"
            class="custom-btn-block d-block mx-auto mt-3"
            styleType="info"
            label="Destacar Publicación" />
          <router-link
            @click.native="resetSellPage"
            :to="{ name: 'home' }"
            :class="`btn ${isHightlighted ? 'btn-primary' : 'btn-link'} text-center my-4`">
            <strong>IR AL INICIO</strong>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isHightlighted: false
  }),

  props: {
    publicationId: Number
  },

  methods: {
    goToHighlights () {
      this.$router.push({ name: 'highlights', params: { id: this.publicationId, screen: 'opciones' }, query: { highlight: true } })
    },

    resetSellPage () {
      this.$store.dispatch('sell/resetInitialState')
        .then(() => {
          this.$parent.$destroy()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/globals';
  @import '../../../scss/breakpoints';

  .sell-online {
    &-body {
    background-color: white;
    }

    &-image {
      background-repeat: no-repeat;
      background-position: 50% 50%;
      height: 240px;

      &.hl {
        background-image: url($CDN_STATIC + '/static/img/pub-online.png');
      }

      &.not-hl {
        background-image: url($CDN_STATIC + '/static/img/rocket.png');
        background-size: contain;
      }
    }

  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .custom-btn-block {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/screens/ScreenOnline.vue